// This class defines all headers per country. Follow the same pattern as below if a subheader or country is added/changed
// LoanType is handled and filtered in backend hence not included here.

export enum LoanHeaders {
	LoanNumber = 'Loannumber',
	Balance = 'Balance',
	TotalBalance = 'TotalBalance',
	Product = 'Product',
	Partner = 'Partner',
	OpeningDate = 'Openingdate',
}

export enum PaymentInfoHeaders {
	Amount = 'Amount',
	PastDueAmount = 'PastDueAmount',
	ExpirationDate = 'ExpirationDate',
	OCR = 'OCRLoans',
	PlusGiro = 'PlusGiro',
	Receiver = 'Receiver',
}

export enum LoanInfoHeaders {
	CurrentPrincipal = 'CurrentPrincipal',
	MonthlyAmount = 'MonthlyAmount',
	Interest = 'Interest',
	OriginalAmount = 'OriginalAmount',
	Ppi = 'Ppi',
	PpiValidFrom = 'PpiValidFrom',
	IsPaymentHolidayPossible = 'IsPaymentHolidayPossible',
	TotalBalance = 'TotalBalance',
	SignedCreditLimit = 'SignedCreditLimit',
	Overpayment = 'Overpayment',
	BaseInterestRate = 'BaseInterestRate',
	MarginInterestRate = 'MarginInterestRate',
}

export function getCountryHeaders(country: string) {
	return headers[country]
}

const headers: {
	[index: string]: {
		LoanHeaders: string[]
		PaymentInfoHeaders: string[]
		LoanInfoHeaders: string[]
	}
} = {}

// FINLAND
headers['fi'] = {
	LoanHeaders: [
		LoanHeaders.LoanNumber,
		LoanHeaders.Balance,
		LoanHeaders.Product,
		LoanHeaders.Partner,
	],
	PaymentInfoHeaders: [
		PaymentInfoHeaders.Amount,
		PaymentInfoHeaders.ExpirationDate,
		PaymentInfoHeaders.OCR,
		PaymentInfoHeaders.PlusGiro,
	],
	LoanInfoHeaders: [
		LoanInfoHeaders.TotalBalance,
		LoanInfoHeaders.MonthlyAmount,
		LoanInfoHeaders.Interest,
		LoanInfoHeaders.OriginalAmount,
		LoanInfoHeaders.Ppi,
		LoanInfoHeaders.IsPaymentHolidayPossible,
		LoanInfoHeaders.BaseInterestRate,
		LoanInfoHeaders.MarginInterestRate,
	],
}

// ESTONIA
headers['ee'] = {
	LoanHeaders: [
		LoanHeaders.LoanNumber,
		LoanHeaders.Balance,
		LoanHeaders.Product,
		LoanHeaders.Partner,
		LoanHeaders.OpeningDate,
	],
	PaymentInfoHeaders: [
		PaymentInfoHeaders.Amount,
		PaymentInfoHeaders.ExpirationDate,
		PaymentInfoHeaders.OCR,
		PaymentInfoHeaders.PlusGiro,
		PaymentInfoHeaders.Receiver,
	],
	LoanInfoHeaders: [
		LoanInfoHeaders.SignedCreditLimit,
		LoanInfoHeaders.CurrentPrincipal,
		LoanInfoHeaders.MonthlyAmount,
		LoanInfoHeaders.Overpayment,
		LoanInfoHeaders.Interest,
		LoanInfoHeaders.OriginalAmount,
	],
}

// LATVIA
headers['lv'] = headers['ee']

// LITHUANIA
headers['lt'] = {
	LoanHeaders: [
		LoanHeaders.LoanNumber,
		LoanHeaders.Balance,
		LoanHeaders.Product,
		LoanHeaders.Partner,
		LoanHeaders.OpeningDate,
	],
	PaymentInfoHeaders: [
		PaymentInfoHeaders.Amount,
		PaymentInfoHeaders.ExpirationDate,
		PaymentInfoHeaders.OCR,
		PaymentInfoHeaders.PlusGiro,
		PaymentInfoHeaders.Receiver,
	],
	LoanInfoHeaders: [
		LoanInfoHeaders.SignedCreditLimit,
		LoanInfoHeaders.MonthlyAmount,
		LoanInfoHeaders.Overpayment,		
	],
}

// SWEDEN
headers['se'] = {
	LoanHeaders: [LoanHeaders.LoanNumber, LoanHeaders.Balance],
	PaymentInfoHeaders: [
		PaymentInfoHeaders.Amount,
		PaymentInfoHeaders.ExpirationDate,
		PaymentInfoHeaders.OCR,
		PaymentInfoHeaders.PlusGiro,
	],
	LoanInfoHeaders: [
		LoanInfoHeaders.TotalBalance,
		LoanInfoHeaders.MonthlyAmount,
		LoanInfoHeaders.Interest,
		LoanInfoHeaders.Ppi,
		LoanInfoHeaders.IsPaymentHolidayPossible,
	],
}

//DENMARK
headers['dk'] = {
    LoanHeaders: [
        LoanHeaders.LoanNumber,
        LoanHeaders.Balance,
        LoanHeaders.Product
    ],
    PaymentInfoHeaders: [
        PaymentInfoHeaders.Amount,
        PaymentInfoHeaders.ExpirationDate,
        PaymentInfoHeaders.OCR,
        PaymentInfoHeaders.PlusGiro,
		PaymentInfoHeaders.Receiver
    ],
    LoanInfoHeaders: [
        LoanInfoHeaders.TotalBalance,
        LoanInfoHeaders.MonthlyAmount,
        LoanInfoHeaders.Interest,
        LoanInfoHeaders.OriginalAmount,
        LoanInfoHeaders.Ppi,
        LoanInfoHeaders.BaseInterestRate
    ],
}

//NORWAY
headers['no'] = {
    LoanHeaders: [
        LoanHeaders.LoanNumber,
        LoanHeaders.TotalBalance
    ],
    PaymentInfoHeaders: [
        PaymentInfoHeaders.Amount,
		PaymentInfoHeaders.PastDueAmount,
        PaymentInfoHeaders.ExpirationDate,
        PaymentInfoHeaders.OCR,
        PaymentInfoHeaders.PlusGiro,
		PaymentInfoHeaders.Receiver
    ],
    LoanInfoHeaders: [
        LoanInfoHeaders.TotalBalance,
        LoanInfoHeaders.MonthlyAmount,
        LoanInfoHeaders.Interest,
        LoanInfoHeaders.OriginalAmount,
        LoanInfoHeaders.BaseInterestRate,
    ],
}